import React from "react";
import Select from "react-select";

import { transformOperationOptions } from "../types";

export function AvailableTransformsSelector({
  canUseSQLTransformation,
  transformationOption,
  setTransformationOption,
  isServerSideOnly,
  eventType,
}) {
  return (
    <Select
      options={transformOperationOptions(
        canUseSQLTransformation,
        isServerSideOnly,
        eventType
      )}
      value={transformationOption}
      onChange={setTransformationOption}
    />
  );
}
